import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { PriorityBadge, StatusBadge } from "./Badges";
import { relTime } from "../lib/labels";

const stripHtml = (s) => {
  if (!s) return "";
  const t = document.createElement("div");
  t.innerHTML = s;
  return (t.textContent || t.innerText || "").replace(/\s+/g, " ").trim();
};

export default function ClientRepliesWidget() {
  const [items, setItems] = useState(null);

  const load = async () => {
    try {
      const r = await api.get("/tickets", { params: { unread: "only", limit: 5 } });
      const list = Array.isArray(r.data) ? r.data : (r.data.items || []);
      setItems(list);
    } catch {
      setItems([]);
    }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, []);

  return (
    <Card data-testid="client-replies-widget">
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle className="font-display flex items-center gap-2">
          <span className="inline-block w-2 h-2 rounded-full bg-blue-500"/>
          Réponses client en attente
          {items && items.length > 0 && (
            <span className="ml-1 inline-flex items-center justify-center min-w-[22px] h-[22px] px-1.5 rounded-full bg-blue-500 text-white text-xs font-bold" data-testid="client-replies-count">
              {items.length}
            </span>
          )}
        </CardTitle>
        <Link to="/tickets?view=unread" className="text-sm text-primary hover:underline" data-testid="client-replies-see-all">
          Tout voir →
        </Link>
      </CardHeader>
      <CardContent>
        {!items && <p className="text-sm text-muted-foreground">Chargement…</p>}
        {items && items.length === 0 && (
          <p className="text-sm text-muted-foreground">
            Aucune réponse client en attente. Vous êtes à jour.
          </p>
        )}
        {items && items.length > 0 && (
          <div className="divide-y">
            {items.map((t) => {
              const comments = t.comments || [];
              const lastClient = [...comments].reverse().find((c) => c.author_role === "client");
              const preview = lastClient
                ? stripHtml(lastClient.body).slice(0, 100)
                : stripHtml(t.description || "").slice(0, 100);
              const when = lastClient?.created_at || t.updated_at || t.created_at;
              return (
                <Link key={t.id} to={`/tickets/${t.id}`}
                  data-testid={`client-reply-${t.number}`}
                  className="grid grid-cols-12 gap-3 py-3 items-center hover:bg-muted/40 -mx-4 px-4 transition-colors">
                  <div className="col-span-1 mono text-muted-foreground flex items-center gap-1.5">
                    <span className="inline-block w-2 h-2 rounded-full bg-blue-500 shrink-0"/>
                    #{t.number}
                  </div>
                  <div className="col-span-5">
                    <div className="font-semibold truncate">{t.subject}</div>
                    <div className="text-xs text-muted-foreground truncate">{t.client_name} · {relTime(when)}</div>
                    {preview && (
                      <div className="text-xs text-muted-foreground mt-0.5 truncate italic">« {preview}{preview.length >= 100 ? "…" : ""} »</div>
                    )}
                  </div>
                  <div className="col-span-2"><PriorityBadge value={t.priority}/></div>
                  <div className="col-span-2"><StatusBadge value={t.status}/></div>
                  <div className="col-span-2 text-xs text-right text-muted-foreground">
                    {relTime(when)}
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
